// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__Nrey6","info":"Panel_info__N9vYO","btns":"Panel_btns__F+jry","button":"Panel_button__AEftw"};